import { useState, useCallback } from 'react';
import useSWR from 'swr';
import urlResolver from 'admin/utils/URLResolver';
import { post, fetchAndCreateIfMissing } from './utils';
import { SAVE_STATUS } from 'edrolo/constants/SaveStatus';

export const useActivityResponse = (activityId) => {
  const [status, setStatus] = useState(SAVE_STATUS.SAVED);
  const [responseSaveError, setResponseSaveError] = useState();

  const activityResponseUrl = urlResolver.reverse(
    'api:activities:object:respond',
    { activityId }
  );

  const defaultActivityResponsePostData = {
    block_responses: {},
    collaborators: [],
    ready_for_review: false,
  };

  const {
    data: activityResponse,
    error: activityResponseError,
    mutate: mutateActivityResponse,
  } = useSWR(
    activityResponseUrl,
    fetchAndCreateIfMissing(defaultActivityResponsePostData)
  );

  const saveActivityResponse = useCallback(
    async (updatedActivityResponse) => {
      setStatus(SAVE_STATUS.SAVING);

      const options = {
        optimisticData: updatedActivityResponse,
        rollbackOnError: true,
        revalidate: false,
      };

      try {
        await mutateActivityResponse(
          post(activityResponseUrl, updatedActivityResponse),
          options
        );
        setStatus(SAVE_STATUS.SAVED);
      } catch (error) {
        setStatus(SAVE_STATUS.ERROR);
        setResponseSaveError(error);
      }
    },
    [mutateActivityResponse, activityResponseUrl]
  );

  return {
    activityResponse,
    activityResponseError,
    status,
    activityResponseIsLoading: !activityResponseError && !activityResponse,
    saveActivityResponse,
    responseSaveError,
  };
};
